import ActionType from 'actions/ActionType'
import extractEmail from 'utils/extractEmail'

export default (
  state = { current: { type: null, value: '' }, manuallyChanged: {} },
  action,
) => {
  switch (action.type) {
    case ActionType.Inbox.REPLY_TO_EMAIL:
      if (
        action.contact &&
        action.contact.id &&
        action.payload &&
        action.payload.direction &&
        action.payload.from &&
        action.payload.to &&
        action.payload.to[0] &&
        action.payload.to[0].to &&
        action.contact.email &&
        action.contact.email.length
      ) {
        const emailsArr = action.contact.email.reduce((acc, el) => {
          if (el.address) acc.push(el.address)
          return acc
        }, [])

        let value = 'Unknown'

        if (action.payload.direction === 'outbound') {
          if (extractEmail(action.payload.to[0].to)) {
            value = extractEmail(action.payload.to[0].to)
          }
        } else {
          if (
            extractEmail(action.payload.from) &&
            emailsArr.includes(extractEmail(action.payload.from))
          ) {
            value = extractEmail(action.payload.from)
          } else {
            value = emailsArr[0]
          }
        }

        return {
          ...state,
          current: {
            type: 'email',
            value,
          },
          // manuallyChanged: {
          //   [action.contact.id]: {
          //     type: 'email',
          //     value,
          //   },
          // },
        }
      }
      return state
    case ActionType.Inbox.CHANGE_TO:
      return {
        current: { value: action.payload, type: action.messageType },
        // manuallyChanged: {
        //   ...state.manuallyChanged,
        //   [action.contactID]: {
        //     value: action.payload,
        //     type: action.messageType,
        //   },
        // },
      }
    case ActionType.Inbox.SELECT_CONTACT:
      return action.payload && action.payload.email && action.payload.email[0]
        ? {
            ...state,
            current: { value: action.payload.email[0].address, type: 'email' },
          }
        : action.payload && action.payload.phones && action.payload.phones[0]
        ? {
            ...state,
            current: { value: action.payload.phones[0].number, type: 'text' },
          }
        : { ...state, current: { value: '', type: 'email' } }
    case ActionType.Inbox.SELECT_CONVERSATION:
      return action.contact && action.contact.email && action.contact.email[0]
        ? {
            ...state,
            current: { value: action.contact.email[0].address, type: 'email' },
          }
        : action.contact && action.contact.phones && action.contact.phones[0]
        ? {
            ...state,
            current: { value: action.contact.phones[0].number, type: 'text' },
          }
        : state
    // case ActionType.Data.READ_SUCCESS:
    // 	if (
    // 		action.entityType === 'inbox' &&
    // 		action.payload.contact_id &&
    // 		action.payload.contact /* &&
    //     !state.manuallyChanged[action.payload.contact_id] */
    // 	) {
    // 		const emailsArray =
    // 			action.payload.contact.email && action.payload.contact.email.length
    // 				? action.payload.contact.email.reduce((acc, el) => {
    // 						if (el.address) acc.push(el.address)
    // 						return acc
    // 				  }, [])
    // 				: []

    // 		if (
    // 			Array.isArray(action.payload.conversation) &&
    // 			action.payload.conversation.length
    // 		) {
    // 			// const lastIndex = action.payload.conversation.length - 1
    // 			const lastConversationItem = action.payload.conversation[0]

    // 			if (lastConversationItem.type === 'sms' && lastConversationItem.sms) {
    // 				if (lastConversationItem.direction === 'inbound') {
    // 					return {
    // 						...state,
    // 						current: {
    // 							value: lastConversationItem.sms.originator_number || '',
    // 							type: 'text',
    // 						},
    // 					}
    // 				}
    // 				if (lastConversationItem.direction === 'outbound') {
    // 					return {
    // 						...state,
    // 						current: {
    // 							value: lastConversationItem.sms.recipient_number || '',
    // 							type: 'text',
    // 						},
    // 					}
    // 				}
    // 				return state
    // 			}

    // 			if (lastConversationItem.type === 'email') {
    // 				const latestEmail =
    // 					lastConversationItem.thread &&
    // 					lastConversationItem.thread.emails &&
    // 					lastConversationItem.thread.emails[0]
    // 				if (latestEmail) {
    // 					const direction = latestEmail.direction
    // 					if (direction === 'inbound') {
    // 						return {
    // 							...state,
    // 							current: {
    // 								value: emailsArray.includes(extractEmail(latestEmail.from))
    // 									? extractEmail(latestEmail.from)
    // 									: emailsArray.length
    // 									? emailsArray[0]
    // 									: 'Unknown',
    // 								type: 'email',
    // 							},
    // 						}
    // 					}
    // 					if (
    // 						direction === 'outbound' &&
    // 						latestEmail.to[0] &&
    // 						latestEmail.to[0].to
    // 					) {
    // 						return {
    // 							...state,
    // 							current: {
    // 								value: extractEmail(latestEmail.to[0].to) || '',
    // 								type: 'email',
    // 							},
    // 						}
    // 					}
    // 					return state
    // 				}
    // 				return state
    // 			}

    // 			if (lastConversationItem.type === 'call') {
    // 				if (lastConversationItem.direction === 'inbound') {
    // 					return {
    // 						...state,
    // 						current: {
    // 							value: lastConversationItem.call.originator_number || '',
    // 							type: 'call',
    // 						},
    // 					}
    // 				}
    // 				if (lastConversationItem.direction === 'outbound') {
    // 					return {
    // 						...state,
    // 						current: {
    // 							value: lastConversationItem.call.recipient_number || '',
    // 							type: 'call',
    // 						},
    // 					}
    // 				}
    // 				return state
    // 			}

    // 			return state
    // 		}
    // 		return state
    // 	}
    // 	return state
    // case ActionType.Inbox.SELECT_CONVERSATION:
    default:
      return state
  }
}
